<template>
  <!--  SENT  -->

  <router-link-modified v-if="vacancy.sended"
                        :to="{ name: 'account-my-vacancies'}"
                        class="base-btn  base-btn--outline-green">
    <span>{{ $tVacancy('My responds') }}</span>
  </router-link-modified>

  <!--  END SENT  -->


  <!--  DISABLED  -->

  <button v-else-if="isDisabled && isEmployee"
          @click.prevent="subscribeOnVacancy"
          class="base-btn  base-btn--outline-green">
    <span>{{ $tVacancy('Report about new vacancies') }}</span>
  </button>
  <button v-else-if="isDisabled && isLogged"
          @click.prevent="openLoginAsUser"
          class="base-btn  base-btn--outline-green">
    <span>{{ $tVacancy('Report about new vacancies') }}</span>
  </button>
  <router-link-modified v-else-if="isDisabled"
                        :to="{name: 'auth', query: {'for-respond': vacancy.ID}}"
                        @click.native="onResponseStatistic"
                        class="base-btn  base-btn--outline-green">
    <span>{{ $tVacancy('Report about new vacancies') }}</span>
  </router-link-modified>

  <!--  END DISABLED  -->

  <!--  ENABLED  -->

  <button v-else-if="isEmployee"
          @click.prevent="respondOnVacancy"
          class="base-btn  base-btn--outline-green">
    <span>{{ $tVacancy('Respond') }}</span>
    <BaseSvg name="ico-arrow-light"/>
    <BasePreloader v-if="small && pendingRespond"
                   class="_small"/>
    <BasePreloader v-else-if="pendingRespond"
                   class="_small"/>
  </button>
  <button
    v-else-if="isAgent || isPartner"
    class="base-btn base-btn--outline-green"
    @click.prevent="openSelectCandidatePopup"
  >
    <span>{{ $tVacancy('Respond') }}</span>
    <BaseSvg name="ico-arrow-light"/>
  </button>
  <button v-else-if="isLogged"
          @click.prevent="openLoginAsUser"
          class="base-btn  base-btn--outline-green">
    <span>{{ $tVacancy('Respond') }}</span>
    <BaseSvg name="ico-arrow-light"/>
  </button>
  <button
    v-else
    class="base-btn  base-btn--outline-green"
    @click="onNotLoggedInResponse"
  >
    <span>{{ $tVacancy('Respond') }}</span>
    <BaseSvg name="ico-arrow-light"/>
  </button>

  <!--  END ENABLED  -->
</template>

<script>
  import {EMPLOYEE} from '@/constants/usersTypes'
  import {onResponseStatistic} from '@/services/statistic'
  import respondOnVacancy from '@/actions/respondOnVacancy'
  import { http } from '../../axios';
  import {mapActions, mapGetters} from 'vuex';

  export default {
    name: 'VacancyMainRespondBtn',
    props: {
      vacancy: Object,
      small: Boolean
    },
    data() {
      return {
        pendingRespond: false,
        phonePopupErrors: [],
      }
    },
    computed: {
      ...mapGetters('user', [
        'isPartner',
        'isAgent',
      ]),

      vacancyId() {
        return this.vacancy.ID
      },
      isLogged() {
        return this.$store.getters['user/isLogged']
      },
      isEmployee() {
        return this.$store.state.user.profile
          && this.$store.state.user.profile.user_type === EMPLOYEE
      },
      isDisabled() {
        if (!this.vacancy[1].quantity) return true

        return false
      },
    },
    watch: {
      phonePopupErrors(errors) {
        this.$eventBus.$emit('enter-phone-number-modal-errors', errors);
      },
    },
    methods: {
      ...mapActions('user', [
        'loginByToken'
      ]),

      onResponseStatistic,
      async respondOnVacancy() {
        this.pendingRespond = true

        const data = await respondOnVacancy(this.vacancyId)
          .then(() => this.vacancy.sended = true)
          .finally(() => this.pendingRespond = false);

        if (data && !['STATUS_SUCCESS', 'STATUS_RESUME_FOUNT_ON_THIS_VACANCY'].includes(data.status) && (data.need_redirect ?? true)) {
          this.$router.push({ name: 'response-additional-questions' });
        }

        this.$store.dispatch('user/loadUser');
      },
      subscribeOnVacancy() {
        this.$vModal.open('subscribe-on-vacancy', {
          vacancyId: this.vacancyId
        })
      },
      openSelectCandidatePopup() {
        this.$vModal.open('select-candidate-for-response', {
          vacancyId: this.vacancyId,
        });
      },
      openLoginAsUser() {
        this.$vModal.open('auth-as-employee-for-subscribe-on-vacancy', {
          vacancyId: this.vacancyId
        })
      },
      onNotLoggedInResponse() {
        this.$vModal.open('enter-phone-number', {
          onSubmit: this.onNotLoggedInResponseSubmit,
        });
      },
      async onNotLoggedInResponseSubmit({ name, phone }) {
        const { query } = this.$route;

        onResponseStatistic();

        this.phonePopupErrors = [];

        try {
          const { data } = await http.post('/api/auth/login-by-phone', {
            phone,
            firstname: name,
            referal_code: query.referal_code,
            for_respond: this.vacancy.ID,
          });

          this.loginByToken(data.data);
          this.vacancy.sended = true;
          this.$router.push({ name: 'response-additional-questions' });
        } catch (e) {
          const  { code, message } = e.response.data;
          if (code === 60) {
            this.phonePopupErrors.push(message);
            return;
          }

          this.$router.push({ name: 'auth', query: { phone, ...query } });
        } finally {
          if (!this.phonePopupErrors.length) this.$vModal.close('enter-phone-number');
        }
      },
    }
  }
</script>

<style lang="less">

</style>
